import { useEffect, useState } from 'react';

const CarImageCarousel = ({ imageUrls }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);

  // autoplay only when modal not open
  useEffect(() => {
    if (imageUrls.length > 1 && !modalOpen) {
      const interval = setInterval(() => {
        setCurrentIndex((prev) => (prev + 1) % imageUrls.length);
      }, 3000);
      return () => clearInterval(interval);
    }
  }, [imageUrls, modalOpen]);

  // scroll to top and prevent background scroll when modal opens
  useEffect(() => {
    if (modalOpen) {
      window.scrollTo(0, 0);
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [modalOpen]);

  if (!imageUrls || imageUrls.length === 0) return null;

  return (
    <div className="w-full max-w-2xl mx-auto relative">
      {/* main image display */}
      <div
        className="w-full aspect-video bg-black rounded-xl shadow-md overflow-hidden cursor-pointer"
        onClick={() => setModalOpen(true)}
      >
        <img
          src={imageUrls[currentIndex]}
          alt={`Car ${currentIndex + 1}`}
          className="w-full h-full object-contain"
        />
      </div>

      {/* thumbnails */}
      {imageUrls.length > 1 && (
        <div className="mt-4 overflow-x-auto">
          <div className="flex space-x-2 w-max px-1">
            {imageUrls.map((url, idx) => (
              <img
                key={idx}
                src={url}
                alt={`Thumb ${idx + 1}`}
                className={`w-16 h-16 object-cover rounded-md cursor-pointer border-2 ${
                  idx === currentIndex ? 'border-blue-500' : 'border-transparent'
                }`}
                onClick={() => setCurrentIndex(idx)}
              />
            ))}
          </div>
        </div>
      )}

      {/* modal full screen */}
      {modalOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-90 z-50 overflow-y-auto flex flex-col items-center pt-20 pb-10 px-4"
          onClick={() => setModalOpen(false)}
        >
          {/* close button */}
          <button
            className="fixed top-4 right-4 text-white text-3xl z-50"
            onClick={() => setModalOpen(false)}
          >
            &times;
          </button>

          {/* modal image grid */}
          <div
            className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 w-full max-w-6xl"
            onClick={(e) => e.stopPropagation()}
          >
            {imageUrls.map((url, idx) => (
              <div key={idx} className="bg-white p-2 rounded-md">
                <img
                  src={url}
                  alt={`Full ${idx + 1}`}
                  className="w-full h-auto object-contain rounded-md"
                  style={{ maxHeight: '500px' }}
                />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CarImageCarousel;
